import React, { useState } from "react";

export default function ManageAbout() {
  const [formData, setFormData] = useState({
    // ✅ HERO SECTION
    hero: {
      title: "About Dev Sols",
      subtitle:
        "We are a forward-thinking software company, empowering businesses with scalable and innovative digital solutions.",
      background:
        "https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=1600",
    },

    // ✅ WHO WE ARE
    whoWeAre: {
      title: "Who We Are",
      text1:
        "Dev Sols is a trusted technology partner for startups, enterprises, and global businesses. We specialize in creating seamless digital experiences through web & mobile development, digital marketing, and technical consulting.",
      text2:
        "With a dedicated team of developers, designers, and consultants, we combine innovation with technical excellence to help businesses scale efficiently.",
      image:
        "https://images.pexels.com/photos/3184360/pexels-photo-3184360.jpeg?auto=compress&cs=tinysrgb&w=1600",
    },

    // ✅ MISSION & VISION
    mission: {
      title: "Our Mission",
      text: "To empower businesses with cutting-edge technology solutions that drive innovation, growth, and long-term success.",
      image:
        "https://images.pexels.com/photos/3184460/pexels-photo-3184460.jpeg?auto=compress&cs=tinysrgb&w=800",
    },
    vision: {
      title: "Our Vision",
      text: "To become a global leader in digital transformation, delivering solutions that shape the future of businesses worldwide.",
      image:
        "https://images.pexels.com/photos/3184306/pexels-photo-3184306.jpeg?auto=compress&cs=tinysrgb&w=800",
    },

    // ✅ CORE VALUES
    coreValues: [
      {
        title: "Innovation",
        desc: "We embrace creativity and cutting-edge technologies.",
        img: "https://images.pexels.com/photos/3184639/pexels-photo-3184639.jpeg?auto=compress&cs=tinysrgb&w=800",
      },
      {
        title: "Transparency",
        desc: "Open communication & honesty in every project we deliver.",
        img: "https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=800",
      },
      {
        title: "Excellence",
        desc: "We strive for the highest quality in all our solutions.",
        img: "https://images.pexels.com/photos/3184302/pexels-photo-3184302.jpeg?auto=compress&cs=tinysrgb&w=800",
      },
      {
        title: "Customer First",
        desc: "Your success is our priority and our driving force.",
        img: "https://images.pexels.com/photos/3184419/pexels-photo-3184419.jpeg?auto=compress&cs=tinysrgb&w=800",
      },
    ],

    // ✅ TEAM MEMBERS
    teamMembers: [
      {
        name: "Omar Arshad",
        role: "CEO & Founder",
        img: "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=400",
      },
      {
        name: "Sarah Khan",
        role: "Project Manager",
        img: "https://images.pexels.com/photos/1181686/pexels-photo-1181686.jpeg?auto=compress&cs=tinysrgb&w=400",
      },
      {
        name: "Ali Raza",
        role: "Lead Developer",
        img: "https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg?auto=compress&cs=tinysrgb&w=400",
      },
    ],

    // ✅ CEO MESSAGE
    ceo: {
      message:
        "At Dev Sols, we believe technology is more than just code. It’s about creating meaningful digital experiences that transform businesses and improve lives. Our team is committed to excellence, innovation, and building long-lasting partnerships with our clients.",
      name: "Omar Arshad",
      role: "CEO & Founder, Dev Sols",
      image:
        "https://images.pexels.com/photos/3777559/pexels-photo-3777559.jpeg?auto=compress&cs=tinysrgb&w=1200",
    },

    // ✅ IMPACT NUMBERS
    impact: [
      { num: "120+", text: "Projects Completed" },
      { num: "50+", text: "Global Clients" },
      { num: "10+", text: "Years of Expertise" },
    ],

    // ✅ FINAL CTA
    finalCTA: {
      title: "Want to Work With Us?",
      subtitle:
        "We’re always ready to collaborate with ambitious businesses and bring their digital ideas to life.",
      button: { text: "Get in Touch", link: "/contact" },
    },
  });

  // ✅ Helpers for updating state
  const updateField = (section, key, value) => {
    setFormData({ ...formData, [section]: { ...formData[section], [key]: value } });
  };

  const updateArrayItem = (section, idx, key, value) => {
    const arr = [...formData[section]];
    arr[idx][key] = value;
    setFormData({ ...formData, [section]: arr });
  };

  const addArrayItem = (section, newItem) => {
    setFormData({ ...formData, [section]: [...formData[section], newItem] });
  };

  const removeArrayItem = (section, idx) => {
    const arr = [...formData[section]];
    arr.splice(idx, 1);
    setFormData({ ...formData, [section]: arr });
  };

  const handleImageUpload = (section, idx, key, file) => {
    const url = URL.createObjectURL(file);
    if (typeof idx === "number") {
      updateArrayItem(section, idx, key, url);
    } else {
      updateField(section, key, url);
    }
  };

  const saveAboutPage = () => {
    console.log("✅ Saving About Page Content:", formData);
    alert("✅ About Page content saved! (Later connect to API)");
  };

  return (
    <div className="space-y-8 p-6">
      <h1 className="text-3xl font-bold">ℹ️ Manage About Page</h1>

      {/* ✅ HERO SECTION */}
      <section className="bg-white p-6 rounded shadow space-y-4">
        <h2 className="text-xl font-bold">Hero Section</h2>
        <input
          className="w-full border p-2 rounded"
          value={formData.hero.title}
          onChange={(e) => updateField("hero", "title", e.target.value)}
        />
        <textarea
          className="w-full border p-2 rounded"
          value={formData.hero.subtitle}
          onChange={(e) => updateField("hero", "subtitle", e.target.value)}
        />
        {formData.hero.background && (
          <img src={formData.hero.background} className="w-full max-w-md rounded" />
        )}
        <input
          type="file"
          onChange={(e) =>
            handleImageUpload("hero", null, "background", e.target.files[0])
          }
        />
      </section>

      {/* ✅ WHO WE ARE */}
      <section className="bg-white p-6 rounded shadow space-y-4">
        <h2 className="text-xl font-bold">Who We Are</h2>
        <input
          className="w-full border p-2 rounded"
          value={formData.whoWeAre.title}
          onChange={(e) => updateField("whoWeAre", "title", e.target.value)}
        />
        <textarea
          className="w-full border p-2 rounded"
          value={formData.whoWeAre.text1}
          onChange={(e) => updateField("whoWeAre", "text1", e.target.value)}
        />
        <textarea
          className="w-full border p-2 rounded"
          value={formData.whoWeAre.text2}
          onChange={(e) => updateField("whoWeAre", "text2", e.target.value)}
        />
        {formData.whoWeAre.image && (
          <img src={formData.whoWeAre.image} className="w-full max-w-md rounded" />
        )}
        <input
          type="file"
          onChange={(e) =>
            handleImageUpload("whoWeAre", null, "image", e.target.files[0])
          }
        />
      </section>

      {/* ✅ MISSION & VISION */}
      {["mission", "vision"].map((section) => (
        <section key={section} className="bg-white p-6 rounded shadow space-y-4">
          <h2 className="text-xl font-bold">{formData[section].title}</h2>
          <textarea
            className="w-full border p-2 rounded"
            value={formData[section].text}
            onChange={(e) => updateField(section, "text", e.target.value)}
          />
          {formData[section].image && (
            <img src={formData[section].image} className="w-full max-w-md rounded" />
          )}
          <input
            type="file"
            onChange={(e) =>
              handleImageUpload(section, null, "image", e.target.files[0])
            }
          />
        </section>
      ))}

      {/* ✅ CORE VALUES */}
      <section className="bg-white p-6 rounded shadow space-y-4">
        <h2 className="text-xl font-bold">Core Values</h2>
        {formData.coreValues.map((val, i) => (
          <div key={i} className="border p-3 rounded space-y-2">
            <input
              className="w-full border p-2 rounded"
              value={val.title}
              onChange={(e) => updateArrayItem("coreValues", i, "title", e.target.value)}
            />
            <textarea
              className="w-full border p-2 rounded"
              value={val.desc}
              onChange={(e) => updateArrayItem("coreValues", i, "desc", e.target.value)}
            />
            {val.img && <img src={val.img} className="w-48 rounded" />}
            <input
              type="file"
              onChange={(e) =>
                handleImageUpload("coreValues", i, "img", e.target.files[0])
              }
            />
            <button
              onClick={() => removeArrayItem("coreValues", i)}
              className="bg-red-500 text-white px-3 py-1 rounded"
            >
              ❌ Remove
            </button>
          </div>
        ))}
        <button
          onClick={() =>
            addArrayItem("coreValues", { title: "", desc: "", img: "" })
          }
          className="bg-blue-500 text-white px-3 py-1 rounded"
        >
          ➕ Add Core Value
        </button>
      </section>

      {/* ✅ TEAM MEMBERS */}
      <section className="bg-white p-6 rounded shadow space-y-4">
        <h2 className="text-xl font-bold">Team Members</h2>
        {formData.teamMembers.map((member, i) => (
          <div key={i} className="border p-3 rounded space-y-2">
            <input
              className="w-full border p-2 rounded"
              value={member.name}
              onChange={(e) =>
                updateArrayItem("teamMembers", i, "name", e.target.value)
              }
            />
            <input
              className="w-full border p-2 rounded"
              value={member.role}
              onChange={(e) =>
                updateArrayItem("teamMembers", i, "role", e.target.value)
              }
            />
            {member.img && <img src={member.img} className="w-32 h-32 rounded-full" />}
            <input
              type="file"
              onChange={(e) =>
                handleImageUpload("teamMembers", i, "img", e.target.files[0])
              }
            />
            <button
              onClick={() => removeArrayItem("teamMembers", i)}
              className="bg-red-500 text-white px-3 py-1 rounded"
            >
              ❌ Remove
            </button>
          </div>
        ))}
        <button
          onClick={() =>
            addArrayItem("teamMembers", { name: "", role: "", img: "" })
          }
          className="bg-blue-500 text-white px-3 py-1 rounded"
        >
          ➕ Add Team Member
        </button>
      </section>

      {/* ✅ CEO MESSAGE */}
      <section className="bg-white p-6 rounded shadow space-y-4">
        <h2 className="text-xl font-bold">CEO Message</h2>
        <textarea
          className="w-full border p-2 rounded"
          value={formData.ceo.message}
          onChange={(e) => updateField("ceo", "message", e.target.value)}
        />
        <input
          className="w-full border p-2 rounded"
          value={formData.ceo.name}
          onChange={(e) => updateField("ceo", "name", e.target.value)}
        />
        <input
          className="w-full border p-2 rounded"
          value={formData.ceo.role}
          onChange={(e) => updateField("ceo", "role", e.target.value)}
        />
        {formData.ceo.image && (
          <img src={formData.ceo.image} className="w-full max-w-md rounded" />
        )}
        <input
          type="file"
          onChange={(e) =>
            handleImageUpload("ceo", null, "image", e.target.files[0])
          }
        />
      </section>

      {/* ✅ IMPACT NUMBERS */}
      <section className="bg-white p-6 rounded shadow space-y-4">
        <h2 className="text-xl font-bold">Impact Numbers</h2>
        {formData.impact.map((stat, i) => (
          <div key={i} className="flex gap-2">
            <input
              className="w-24 border p-2 rounded"
              value={stat.num}
              onChange={(e) => updateArrayItem("impact", i, "num", e.target.value)}
            />
            <input
              className="flex-1 border p-2 rounded"
              value={stat.text}
              onChange={(e) => updateArrayItem("impact", i, "text", e.target.value)}
            />
            <button
              onClick={() => removeArrayItem("impact", i)}
              className="bg-red-500 text-white px-3 rounded"
            >
              ❌
            </button>
          </div>
        ))}
        <button
          onClick={() => addArrayItem("impact", { num: "", text: "" })}
          className="bg-blue-500 text-white px-3 py-1 rounded"
        >
          ➕ Add Stat
        </button>
      </section>

      {/* ✅ FINAL CTA */}
      <section className="bg-white p-6 rounded shadow space-y-4">
        <h2 className="text-xl font-bold">Final CTA</h2>
        <input
          className="w-full border p-2 rounded"
          value={formData.finalCTA.title}
          onChange={(e) => updateField("finalCTA", "title", e.target.value)}
        />
        <textarea
          className="w-full border p-2 rounded"
          value={formData.finalCTA.subtitle}
          onChange={(e) => updateField("finalCTA", "subtitle", e.target.value)}
        />
        <input
          className="w-full border p-2 rounded"
          value={formData.finalCTA.button.text}
          onChange={(e) =>
            updateField("finalCTA", "button", {
              ...formData.finalCTA.button,
              text: e.target.value,
            })
          }
        />
        <input
          className="w-full border p-2 rounded"
          value={formData.finalCTA.button.link}
          onChange={(e) =>
            updateField("finalCTA", "button", {
              ...formData.finalCTA.button,
              link: e.target.value,
            })
          }
        />
      </section>

      {/* ✅ SAVE BUTTON */}
      <div className="text-center">
        <button
          onClick={saveAboutPage}
          className="bg-green-500 text-white px-6 py-3 rounded font-bold"
        >
          ✅ Save About Page
        </button>
      </div>
    </div>
  );
}
